// extracted by mini-css-extract-plugin
module.exports = {"grid":"ProductShowcase_grid__u5P2A"};